import { useCallback, useEffect, useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import OpenAIKeyInput from "@/components/admin/OpenAIKeyInput";

export default function DefaultOpenAIKey() {
  const [info, setInfo] = useState(null);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    setError("");
    try { const { data } = await api.get("/settings/default-openai-key"); setInfo(data); }
    catch (failure) { setError(apiError(failure)); }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings/default-openai-key", { api_key: value.trim() });
      setInfo((previous) => ({ ...previous, ...data, unavailable: false })); setValue("");
      toast.success("API key default disimpan");
    } catch (error) { toast.error(apiError(error)); }
    finally { setSaving(false); }
  };
  const clear = async () => {
    if (!info?.configured) { setValue(""); return; }
    setSaving(true);
    try {
      await api.delete("/settings/default-openai-key");
      setInfo((previous) => ({ ...previous, configured: false, masked: "", unavailable: false })); setValue("");
      toast.success("API key default dihapus");
    } catch (error) { toast.error(apiError(error)); }
    finally { setSaving(false); }
  };
  return (
    <div className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-2xl p-4 sm:p-6 lg:col-span-2 space-y-3" data-testid="default-openai-key-card">
      <h2 className="font-heading font-bold flex items-center gap-2"><KeyRound size={18} className="text-purple-600" />API Key Default (OpenAI)</h2>
      <p className="text-xs text-slate-600">Dipakai bisnis yang belum memiliki key OpenAI sendiri. Jika kosong, aplikasi memakai OPENAI_API_KEY dari environment backend.</p>
      <p className="text-xs text-slate-600" data-testid="def-key-masked">{info ? (info.configured ? `Terpasang ${info.masked || ""}` : "Belum diatur") : "Memuat status key..."}</p>
      {error && <div role="alert" className="text-xs text-red-600">{error}<Button type="button" variant="outline" onClick={load} className="ml-2" data-testid="def-key-retry">Coba lagi</Button></div>}
      <OpenAIKeyInput value={value} onChange={setValue} onClear={clear} masked={info?.masked || ""} unavailable={info?.unavailable} prefix="def-openai-key" disabled={saving || !info} />
      <Button onClick={save} disabled={saving || !info || !value.trim()} data-testid="def-openai-key-save-button" className="bg-[#2563EB] rounded-xl">{saving && <Loader2 size={14} className="mr-1 animate-spin" />}Simpan</Button>
    </div>
  );
}
